import tinymce, { initTinyMCE } from "../helper/tinymce";
import Swal from "sweetalert2";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import { initContactImportExport } from "./contact-import-export";

document.addEventListener("DOMContentLoaded", function () {
  initContactImportExport();

  const sendMessageBtns = document.querySelectorAll(".btn-send-message");
  const sendMessageModalElement = document.getElementById("sendMessageModal");
  const batchMessageModalElement = document.getElementById("batchMessageContactModal");

  window.tinymce = tinymce;

  if (sendMessageModalElement) {
    sendMessageModalElement.addEventListener("show.bs.modal", function () {
      initTinyMCE("#message-body");
    });

    sendMessageModalElement.addEventListener("hidden.bs.modal", function () {
      tinymce.remove("#message-body");
    });
  }

  if (batchMessageModalElement) {
    batchMessageModalElement.addEventListener("show.bs.modal", function () {
      initTinyMCE("#batch-message-body");
    });

    batchMessageModalElement.addEventListener("hidden.bs.modal", function () {
      tinymce.remove("#batch-message-body");
    });
  }

  if (sendMessageBtns.length > 0 && sendMessageModalElement) {
    sendMessageBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const email = this.getAttribute("data-email");
        const telefon = this.getAttribute("data-telefon");
        const facebook = this.getAttribute("data-facebook");
        const instagram = this.getAttribute("data-instagram");

        const hasEmail = email && email.trim() !== "" && email !== "null";
        const hasTelefon = telefon && telefon.trim() !== "" && telefon !== "null";
        const hasFacebook = facebook && facebook.trim() !== "" && facebook !== "null";
        const hasInstagram = instagram && instagram.trim() !== "" && instagram !== "null";

        if (!hasEmail && !hasTelefon && !hasFacebook && !hasInstagram) {
          Swal.fire({
            icon: "warning",
            title: "Keine Kontaktdaten vorhanden",
            text: "Diesem Kontakt sind keine Kontaktwege (E-Mail, Telefon, Social Media) zugeordnet. Bitte ergänzen Sie diese in den Basisdaten, um eine Nachricht senden zu können.",
            confirmButtonText: "Verstanden",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        } else {
          const modal = bootstrap.Modal.getOrCreateInstance(sendMessageModalElement);
          modal.show();
        }
      });
    });
  }
});
